import { render, staticRenderFns } from "./product-properites.vue?vue&type=template&id=076b531e&scoped=true&"
import script from "./product-properites.vue?vue&type=script&lang=ts&"
export * from "./product-properites.vue?vue&type=script&lang=ts&"
import style0 from "./product-properites.vue?vue&type=style&index=0&id=076b531e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "076b531e",
  null
  
)

export default component.exports